import { useState, useEffect, useRef } from "react";
import { COUNTRIES, flagOf } from "./countries";
import styles from "./form.module.css";

const CountrySelect = ({ selected, onSelect, error }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setQ("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const list = COUNTRIES.filter(
    (c) =>
      !q ||
      c.name.toLowerCase().includes(q.toLowerCase()) ||
      c.dial.includes(q) ||
      c.iso.toLowerCase() === q.toLowerCase(),
  );

  return (
    <div ref={ref} className={styles.selectWrap}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`${styles.selectTrigger} ${error ? styles.err : ""}`}
      >
        <span className={styles.selectFlag}>{flagOf(selected.iso)}</span>
        <span className={styles.selectDial}>{selected.dial}</span>
        <span className={styles.selectChevron}>▼</span>
      </button>

      {open && (
        <div className={styles.dropdownNarrow}>
          <div className={styles.dropdownSearch}>
            <input
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search country or code"
              className={styles.dropdownSearchInput}
            />
          </div>
          <div className={styles.dropdownList}>
            {list.length === 0 && (
              <div className={styles.dropdownEmpty}>No matches</div>
            )}
            {list.map((c) => (
              <div
                key={c.iso}
                onClick={() => {
                  onSelect(c);
                  setOpen(false);
                  setQ("");
                }}
                className={`${styles.dropdownItem} ${c.iso === selected.iso ? styles.selected : ""}`}
              >
                <span className={styles.selectFlag}>{flagOf(c.iso)}</span>
                <span className={styles.dropdownItemName}>{c.name}</span>
                <span className={styles.dropdownItemDial}>{c.dial}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}


export default CountrySelect;